export default __webpack_public_path__ + "static/lyons_therapy_logo_orange-6a3a21ae60ed840bda9671aa62c5a46f.png";